import { Directive, Input, ViewContainerRef, Output, EventEmitter } from '@angular/core';
var NgTranscludeDirective = (function () {
    /**
     * @param {?} _viewRef
     */
    function NgTranscludeDirective(_viewRef) {
        this._viewRef = _viewRef;
        this.ngTranscludeChange = new EventEmitter();
        this.viewRef = _viewRef;
    }
    Object.defineProperty(NgTranscludeDirective.prototype, "ngTransclude", {
        /**
         * @return {?}
         */
        get: function () {
            return this._ngTransclude;
        },
        /**
         * @param {?} templateRef
         * @return {?}
         */
        set: function (templateRef) {
            this._ngTransclude = templateRef;
            if (templateRef) {
                this.viewRef.createEmbeddedView(templateRef);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NgTranscludeDirective.prototype.ngAfterContentInit = function () {
        this.ngTranscludeChange.emit(true);
    };
    /**
     * @return {?}
     */
    NgTranscludeDirective.prototype.ngOnDestroy = function () {
        this.viewRef.detach();
    };
    return NgTranscludeDirective;
}());
export { NgTranscludeDirective };
NgTranscludeDirective.decorators = [
    { type: Directive, args: [{
                selector: '[ngTransclude]'
            },] },
];
/**
 * @nocollapse
 */
NgTranscludeDirective.ctorParameters = function () { return [
    { type: ViewContainerRef, },
]; };
NgTranscludeDirective.propDecorators = {
    'ngTransclude': [{ type: Input },],
    'ngTranscludeChange': [{ type: Output },],
};
function NgTranscludeDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    NgTranscludeDirective.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgTranscludeDirective.ctorParameters;
    /** @type {?} */
    NgTranscludeDirective.propDecorators;
    /** @type {?} */
    NgTranscludeDirective.prototype.viewRef;
    /** @type {?} */
    NgTranscludeDirective.prototype._ngTransclude;
    /** @type {?} */
    NgTranscludeDirective.prototype.ngTranscludeChange;
    /** @type {?} */
    NgTranscludeDirective.prototype._viewRef;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/minimal/common.js
// module id = 1360
// module chunks = 31